import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import MoreMenuItem from './MoreMenuItem';
import { signInActions } from 'src/store/modules/signin';

interface IStateFromProps {
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

const mapDispatchToProps = (dispatch: any): any => ({
  signout: () => dispatch(signInActions.signout())
});

export const pureComponent = MoreMenuItem;

export default connect<IStateFromProps, any>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(MoreMenuItem));
